module.exports = __webpack_public_path__ + "static/media/1.14854b34.png";